import React, { FC, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'src/store';
import { changeEnter } from 'src/utils/changeEnter';

const RatingAnswerSurvey_0201: FC = () => {
  const currentIndex = useSelector(
    (state: any) => state.imageUpload.currentIndex
  );
  const text = useSelector((state: RootState) => state.editText.text);
  const btnText = useSelector((state: RootState) => state.buttons.btnText);

  const [selectedOption, sestSelectedOption] = useState([]);

  return (
    <>
      <div className="root_view root_view_0201">
        <div className="template">
          <div className="center_horizon close">
            <button />
          </div>
          <div className="center_wrapper">
            <div className="logo">
              <button />
            </div>
            <div className="title">
              <div className="title_inner">
                {changeEnter(text?.title_0201?.[currentIndex])}
              </div>
            </div>
            <div className="sub_title">
              <div className="sub_title_inner">
                {changeEnter(text?.sub_title_0201?.[currentIndex])}
              </div>
            </div>
            <div className="star_wrapper">
              <div className="star_inner action">
                <button />
              </div>
              {[...Array(4)].map(() => (
                <div className="star_inner">
                  <button />
                </div>
              ))}
            </div>
            <div className="survey_wrapper">
              <div className="survey_inner">
                {btnText?.option_button_0201?.[currentIndex]?.map(
                  (text: string, idx: number) => (
                    <span
                      className={`survey ${selectedOption.indexOf(idx) !== -1 &&
                        'action'}`}
                      onClick={() => {
                        const newSelected = selectedOption.slice();
                        const selectedIndex = selectedOption.indexOf(idx);
                        if (selectedIndex === -1) {
                          newSelected.push(idx);
                        } else {
                          newSelected.splice(selectedIndex, 1);
                        }
                        sestSelectedOption(newSelected);
                      }}
                    >
                      {text}
                    </span>
                  )
                )}
              </div>
            </div>
          </div>
          <div className="center_horizon bottom">
            <button
              className={`button ${selectedOption.length > 0 && 'action'}`}
            >
              {btnText?.button_0201?.[currentIndex]}
            </button>
          </div>
        </div>
      </div>
    </>
  );
};
export default RatingAnswerSurvey_0201;
